module.exports = __webpack_public_path__ + "static/media/cardano.b81b5ae5.jpg";